export function contactMapperListResponse(json, headers) {

  let data = json.map((resource) => ({
    ...resource,
    id: resource.objectId,
    contactId: resource.objectId,
    type: 'contact',
    description: resource.name,
    url: '/contact/' + resource.objectId+'/show',
    // url: {urlClick:'/contact/' + resource.objectId+'/show', urlClue:'/clue/create'},
    customeData:resource,
    content:resource
  }))

  return {
    data,
    total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
  };
}

export function fixUpdateContactId(json) {
  return {
    data: { ...json, id: json.objectId },
  };
}

export function fixCreateContactId(params, json) {
  return {
    data: { ...params.data, id: json.result.objectId },
  };
}

export function fixGetManyContact(json) {
  return {
    data: json.map((resource) => ({
      ...resource,
      id: resource.objectId,
      contactId: resource.objectId,
    })),
  };
}

export function contactMapperGetOneResponse(json) {
  return {
    data: { ...json.result, id: json.result.objectId, contactId: json.result.objectId },
  };
}